import { Alert, Button } from "@mui/material";
export default function ErrorState({
  onRetry,
  message = "Unable to load records. Please try again.",
}) {
  return (
    <Alert
      severity="error"
      sx={{ my: 2 }}
      action={
        onRetry && (
          <Button color="inherit" onClick={onRetry}>
            Try again
          </Button>
        )
      }
    >
      {message}
    </Alert>
  );
}
